$(document).ready(function(){
  $('.site-footer__linklist').append('<li class="site-footer__linklist-item"><a href="tel:+13103701120"><i class="fa fa-phone"></i> (310) 586-3330</a></li>');
  //$('#shopify-section-1550516523885 .grid__item:nth-of-type(1)').prepend('<img src="https://cdn.shopify.com/s/files/1/1805/1933/files/longines-1-logo.jpg?3119433243140273230" alt="Logines Logo">');
  //$('#shopify-section-1550516523885 .grid__item:nth-of-type(2)').prepend('<img src="https://cdn.shopify.com/s/files/1/1805/1933/files/Maurice-Lacroix-600x315.jpg?3119433243140273230" alt="Maurice Logo">');
  //$('#shopify-section-1550516523885 .grid__item:nth-of-type(3)').prepend('<img src="https://cdn.shopify.com/s/files/1/1805/1933/files/g-shock-logo-png-8.jpg?3119433243140273230" alt="G-Shock Logo">');
  
  // Product Page - Make an Offer Option
  $('.expand-btn').click(function(){
    $('.expandable').addClass('open');
  }); 
  $('.expandable .fa-close').click(function(){
    $('.expandable').removeClass('open');
  }); 
});